export const Playicon = ({
  width = 60,
  height = 60,
  color = "#34623F",
  className
}: {
  height?: number | string;
  width?: number | string;
  color?: string;
  className?: string;
}) => {
  return (
    <svg
      width={width}
      className={className}
      height={height}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="60" height="60" rx="30" fill="#D8F7E0" />
      <path d="M28.01 23.8872C26.343 22.9152 24.25 24.1172 24.25 26.0472V33.9532C24.25 35.8832 26.343 37.0852 28.01 36.1132L34.787 32.1592C36.44 31.1952 36.44 28.8052 34.787 27.8412L28.01 23.8872Z" fill={color} />

    </svg>
  );
};
